import React, { useEffect, useState } from 'react';
import { Collapse, Icon, Table } from 'antd';
import { Widget, MasterDetailForm, Row, ColumnProps, Button, FormatText } from '@digital/ui';
import {
    Projeto
} from '@app/api/projeto'
import { formatCurrencyBr, formatCurrencyBrReturnNull } from '@app/helpers/numbers'
import { compareText } from '@app/helpers/comparators';
import { PaginationConfig } from 'antd/lib/pagination';
import { useRecoilState } from 'recoil';
import { aContratarProjetoResult } from '@app/state/atom';
import { mountFormFilterDropDown } from '@app/components/FormFilterDropDown';
import { AContratarEditValue, getAContratarByCrfProjetoId, ResultadoRelatorioPluriAnual, updateAContratarByCrfContaContabilCcId } from '@app/api/crf/crfAContratar';
import CurrencyInput from '@app/components/CurrencyInput';
import ModalComentarioAContratar from './ModalComentarioAContratar';

const { Panel } = Collapse;
interface PropFormAContratar {
    selectedItem: Projeto;
    hasGetADistribuirByCrfProjetoId: (crfProjetoId: string, consultaRelatorio: boolean) => any
}

const FormAContratar = (props: PropFormAContratar) => {
    const larguraPadrao = 150;
    const { selectedItem, hasGetADistribuirByCrfProjetoId } = props;
    const [novoValorAContratar, setNovoValorAContratar] = useState<AContratarEditValue>()
    const [acontratarViewModelResult, setAcontratarViewModelResult] = useRecoilState(aContratarProjetoResult);

    useEffect(() => {
        if (selectedItem)
            getAContratarByProjetoid(selectedItem.id);
    }, [selectedItem]);

    const getAContratarByProjetoid = (projetoId: string) => {
        getAContratarByCrfProjetoId(projetoId).then((resultView) => {
            if (resultView) {
                resultView.children.forEach((agrupador) => {
                    if (agrupador.children.length > 0) {
                        agrupador.children.forEach((contaContabil) => {
                            if (contaContabil.children.length > 0) {
                            }
                        })
                    }
                })
                setAcontratarViewModelResult(resultView);
            }
        });
    }

    const formatformatCurrencyBrReturnNullAContratar = (numeroNivel: number, valor?: number): string => {
        if (valor == undefined)
            valor = 0;

        if (numeroNivel === 1) {
            return formatCurrencyBrReturnNull(valor)
        }
        if (valor)
            return formatCurrencyBrReturnNull(valor)
        return '';
    }

    const formatCurrencyBrReturnNullAContratar = (valor?: number): string => {
        if (valor == undefined)
            valor = 0;
        return formatCurrencyBrReturnNull(valor);
    }

    const collunsAContratar = () => {

        let colluns: ColumnProps<any>[] = [
            {
                title: 'N',
                dataIndex: 'numeroLinha',
                width: larguraPadrao,
            },
            {
                title: 'CÓDIGO',
                dataIndex: 'codigoPacote',
                width: larguraPadrao,
                sorter: (a, b) => compareText(a.codigoPacote, b.codigoPacote),
                ...mountFormFilterDropDown('codigoPacote', 'Pesquisar')
            },
            {
                title: 'NOME',
                dataIndex: 'nome',
                width: larguraPadrao,
                sorter: (a, b) => compareText(a.nome, b.nome),
                ...mountFormFilterDropDown('nome', 'Pesquisar')
            },
            {
                title: `${formatCurrencyBr(acontratarViewModelResult.totalOrcado)}`,
                align: 'center',
                width: larguraPadrao,
                children: [
                    {
                        title: 'A',
                        align: 'center',
                        children: [
                            {
                                title: 'ORÇADO',
                                align: 'center',
                                render: (text: any, record: ResultadoRelatorioPluriAnual, index: number) => {
                                    if (record.numeroNivel === 2)
                                        return [];

                                    if (record.numeroNivel === 1) {
                                        return [<>{formatformatCurrencyBrReturnNullAContratar(record.numeroNivel, record.orcado)}</>]
                                    } else {
                                        if (record.tipoConsolidadoPlurianualCodigo === 1
                                            || record.tipoConsolidadoPlurianualCodigo === 2
                                            || record.tipoConsolidadoPlurianualCodigo === 3) {
                                            return [<>{formatCurrencyBrReturnNullAContratar(record.orcado)}</>]
                                        } else {
                                            if (record.tipoConsolidadoPlurianualCodigo != 4 && record.tipoConsolidadoPlurianualCodigo != 5)
                                                return formatCurrencyBrReturnNull(record.orcado);
                                        }
                                    }

                                    return [];
                                }
                            }]
                    },
                ]
            },
            {
                title: `${formatCurrencyBr(acontratarViewModelResult.totalContratado)}`,
                align: 'center',
                width: larguraPadrao,
                children: [
                    {
                        title: 'B',
                        align: 'center',
                        children: [
                            {
                                title: 'CONTRATADO',
                                align: 'center',
                                render: (text: any, record: ResultadoRelatorioPluriAnual, index: number) => {
                                    if (record.numeroNivel === 2)
                                        return [];

                                    if (record.numeroNivel === 3) {
                                        if (record.tipoConsolidadoPlurianualCodigo != 4 && record.tipoConsolidadoPlurianualCodigo != 5)
                                            return formatCurrencyBrReturnNull(record.contratado);
                                    }
                                    return [<>{formatformatCurrencyBrReturnNullAContratar(record.numeroNivel, record.contratado)}</>]
                                }
                            }]
                    },
                ]
            },
            {
                title: `${formatCurrencyBr(acontratarViewModelResult.totalExecutado)}`,
                align: 'center',
                width: larguraPadrao,
                children: [
                    {
                        title: 'C',
                        align: 'center',
                        children: [
                            {
                                title: 'EXECUTADO',
                                align: 'center',
                                render: (text: any, record: ResultadoRelatorioPluriAnual, index: number) => {


                                    if (record.numeroNivel === 3) {
                                        if (record.tipoConsolidadoPlurianualCodigo != 4 && record.tipoConsolidadoPlurianualCodigo != 5)
                                            return formatCurrencyBrReturnNull(record.executado);
                                    }

                                    return [<>{formatformatCurrencyBrReturnNullAContratar(record.numeroNivel, record.executado)}</>]


                                }
                            }]
                    },
                ]
            },
            {
                title: `${formatCurrencyBr(acontratarViewModelResult.totalRequisitado)}`,
                align: 'center',
                width: larguraPadrao,
                children: [
                    {
                        title: 'D',
                        align: 'center',
                        children: [
                            {
                                title: 'requisitado',
                                align: 'center',
                                render: (text: any, record: ResultadoRelatorioPluriAnual, index: number) => {
                                    // return [<>{formatformatCurrencyBrReturnNullAContratar(record.numeroNivel, record.requisitado)}</>]

                                    if (record.numeroNivel === 2)
                                        return [];

                                    if (record.numeroNivel === 1) {
                                        return [<>{formatformatCurrencyBrReturnNullAContratar(record.numeroNivel, record.requisitado)}</>]
                                    } else {
                                        if (record.tipoConsolidadoPlurianualCodigo === 5) {
                                            return [<>{formatCurrencyBrReturnNullAContratar(record.requisitado)}</>]
                                        } else {
                                            if (record.numeroNivel === 3) {
                                                if (record.tipoConsolidadoPlurianualCodigo != 4 && record.tipoConsolidadoPlurianualCodigo != 5)
                                                    return formatCurrencyBrReturnNull(record.requisitado);
                                            }
                                        }
                                    }

                                    return [];
                                }
                            }]
                    },
                ]
            },
            {
                title: `${formatCurrencyBr(acontratarViewModelResult.totalCompromissadoAno)}`,
                align: 'center',
                width: larguraPadrao,
                children: [
                    {
                        title: 'E = B - C + D',
                        align: 'center',
                        children: [
                            {
                                title: 'COMPROMISSADO',
                                align: 'center',
                                render: (text: any, record: ResultadoRelatorioPluriAnual, index: number) => {


                                    if (record.numeroNivel === 3) {
                                        if (record.tipoConsolidadoPlurianualCodigo != 4 && record.tipoConsolidadoPlurianualCodigo != 5)
                                            return formatCurrencyBrReturnNull(record.compromissadoAno);
                                    }

                                    return [<>{formatformatCurrencyBrReturnNullAContratar(record.numeroNivel, record.compromissadoAno)}</>]
                                }
                            }]
                    },
                ]
            },
            {
                title: `${formatCurrencyBr(acontratarViewModelResult.totalAContratar)}`,
                align: 'center',
                width: larguraPadrao,
                children: [
                    {
                        title: 'F',
                        align: 'center',
                        children: [
                            {
                                title: 'A CONTRATAR',
                                align: 'center',
                                render: (text: any, record: ResultadoRelatorioPluriAnual, index: number) => {
                                    if (record.numeroNivel === 1)
                                        return [<>{formatformatCurrencyBrReturnNullAContratar(record.numeroNivel, record.aContratar)}</>]

                                    if (record.numeroNivel === 3 && record.tipoConsolidadoPlurianualCodigo === 4) {
                                        return [
                                            <CurrencyInput
                                                id={`${record.crfContaContabilCcId}_${'aContrtar'}`}
                                                name={`${record.crfContaContabilCcId}_${'valor'}`}
                                                value={record.aContratar}
                                                onBlur={() => { }}
                                                defaultValue={record.aContratar}
                                                onChange={e => {                                                    
                                                    if (e || e === 0) {
                                                        setNovoValorAContratar({ crfContaContabilCcId: record.crfContaContabilCcId, novoValor: e, key: record.key });
                                                    }
                                                }}
                                                onKeyDown={e => {
                                                    if (e.key === 'Enter') {
                                                        if (novoValorAContratar) {

                                                            salvarAlterarAContratar(novoValorAContratar)
                                                        }

                                                    }
                                                }}
                                            />
                                        ]
                                    }
                                    return [];
                                    // return [<>{formatformatCurrencyBrReturnNullAContratar(record.numeroNivel, record.aContratar)}</>]
                                }
                            }]
                    },
                ]
            },
            {
                title: `${formatCurrencyBr(acontratarViewModelResult.totalForecast)}`,
                align: 'center',
                width: larguraPadrao,
                children: [
                    {
                        title: 'G = B + D + F',
                        align: 'center',
                        children: [
                            {
                                title: 'FORECAST',
                                align: 'center',
                                render: (text: any, record: ResultadoRelatorioPluriAnual, index: number) => {


                                    if (record.numeroNivel === 3) {
                                        if (record.tipoConsolidadoPlurianualCodigo != 5)
                                            return formatCurrencyBrReturnNull(record.forecast);
                                    }

                                    return [<>{formatformatCurrencyBrReturnNullAContratar(record.numeroNivel, record.forecast)}</>]
                                }
                            }]
                    },
                ]
            },
            {
                title: `${formatCurrencyBr(acontratarViewModelResult.totalSaldo)}`,
                align: 'center',
                width: larguraPadrao,
                children: [
                    {
                        title: 'H = A - G',
                        align: 'center',
                        children: [
                            {
                                title: 'SALDO',
                                align: 'center',
                                render: (text: any, record: ResultadoRelatorioPluriAnual, index: number) => {

                                    if (record.numeroNivel === 3) {
                                        if (record.tipoConsolidadoPlurianualCodigo != 5)
                                            return formatCurrencyBrReturnNull(record.saldo);
                                    }


                                    return [<>{formatformatCurrencyBrReturnNullAContratar(record.numeroNivel, record.saldo)}</>]
                                }
                            }]
                    },
                ]
            }
        ];


        colluns.push(
            {
                title: 'COMENTARIOS',
                dataIndex: 'comentarios',
                width: larguraPadrao,
                align: 'center',
                render: (text, record: ResultadoRelatorioPluriAnual) => {
                    if (record.tipoConsolidadoPlurianualCodigo === 4 && record.numeroNivel === 3) {
                        return <ModalComentarioAContratar record={record} />
                    } else {
                        return <> </>
                    }
                }
            },
        )
        return colluns;
    }

    const salvarAlterarAContratar = (novoValor: AContratarEditValue) => {
        updateAContratarByCrfContaContabilCcId(novoValor)
            .then(() => {

                let acontratarViewModelNovo = {
                    ...acontratarViewModelResult,
                    children: acontratarViewModelResult
                        .children
                        .map((itemNivel1a) => {
                            return {
                                ...itemNivel1a,
                                children: itemNivel1a
                                    .children
                                    .map((itemNivel2a) => {
                                        return {
                                            ...itemNivel2a,
                                            children: itemNivel2a
                                                .children
                                                .map((itemNivel3a) => {
                                                    if (itemNivel3a.tipoConsolidadoPlurianualCodigo == 4 && itemNivel3a.key === novoValor.key) {
                                                        return { ...itemNivel3a, aContratar: novoValor.novoValor };
                                                    } else {
                                                        return itemNivel3a;
                                                    }
                                                })
                                        }
                                    })
                            }
                        })
                }
                setAcontratarViewModelResult(acontratarViewModelNovo);
            });
    }

    return (
        <>

            {true ? (
                <Collapse bordered={false} defaultActiveKey={['1']} expandIcon={() => <Icon type="arrows-right_4" />}>
                    <Panel key="1" header="A CONTRATAR PLURIANUAL" style={{ border: 0 }}>
                        <MasterDetailForm>
                            <Widget
                                actions={[
                                    <Button
                                        type="primary"
                                        name="btnAtualizarTabela"
                                        icon="ui-available_updates"
                                        onClick={() => {
                                            getAContratarByProjetoid(selectedItem.id);
                                            hasGetADistribuirByCrfProjetoId(selectedItem.id, false);
                                        }}>
                                        <FormatText id="ui.commons.save" uppercase transform={() => "ATUALIZAR ACONTRATAR E ADISTRIBUIR"} />
                                    </Button>,]}>
                                <Row>
                                    <Table
                                        columns={collunsAContratar()}
                                        dataSource={acontratarViewModelResult ? acontratarViewModelResult.children : []}
                                        id={"tabelaAContratarCrf"}
                                        pagination={{
                                            pageSize: 10,
                                            onChange: (() => {
                                                document.getElementById("tabelaAContratarCrf").scrollIntoView();
                                            })
                                        } as PaginationConfig}
                                    />
                                </Row>
                            </Widget>
                        </MasterDetailForm>
                    </Panel>
                </Collapse>

            ) : (<> </>)}

        </>);
}

export default FormAContratar;